// ***************gallery-slider js****************************
$(document).ready(function () {
  function initSlickSlider() {
    $('.gallery_media_wrapper').slick({
      dots: false,
      centerPadding: '215px',
      infinite: true,
      touchThreshold: 100,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      nextArrow: '<button class="slick-next"><i class="fa fa-caret-right" ></i></button>',
      prevArrow: '<button class="slick-prev"><i class="fa fa-caret-left" ></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerPadding: '100px',
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 300,
            centerMode: false,
            infinite: true
          }
        }
      ]
    });
  }

  function checkWindowSize() {
    if ($(window).width() <= 767) {
      initSlickSlider();
    } else {
      $('.gallery_media_wrapper').slick('unslick');
    }
  }

  checkWindowSize();

  $(window).resize(function () {
    checkWindowSize();
  });
});

 
// ************careers-tab js****************************************************

    function openTab(evt, tabName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", " ");
      }
      document.getElementById(tabName).style.display = "block";
      evt.currentTarget.className += " active";
    }

 